// This file contains a Pixi manifest with bundles for all in-game assets.
import type { AssetsManifest } from "pixi.js";

import Checker_Highlight from "@/game/assets/shared/Checker_Highlight.png";
import OffArea_Highlight from "@/game/assets/shared/OffArea_Highlight.png";
import Point_Highlight from "@/game/assets/shared/Points_Highlight.png";
import Dice_Initial_Roll_BG from "@/game/assets/shared/SpinDiceBG_Beginning.png";
import Dice_Initial_Roll_Highlight from "@/game/assets/shared/SpinDiceBG_Beginning_Highlight.png";
import Dice_Roll_BG from "@/game/assets/shared/SpinDiceBG_Turn.png";

export const CommonManifest: AssetsManifest = {
  bundles: [
    {
      name: "common-gameplay",
      assets: [
        {
          alias: "highlight-point",
          src: Point_Highlight
        },
        {
          alias: "highlight-off-area",
          src: OffArea_Highlight
        },
        {
          alias: "highlight-checker",
          src: Checker_Highlight
        },
        {
          alias: "dice-initial-roll-bg",
          src: Dice_Initial_Roll_BG
        },
        {
          alias: "dice-initial-roll-highlight",
          src: Dice_Initial_Roll_Highlight
        },
        {
          alias: "dice-roll-bg",
          src: Dice_Roll_BG
        }
      ]
    }
  ]
};
